import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import UiButtonInner from './UiButtonInner.vue';

export type ButtonVariant =
  | 'gray'
  | 'red'
  | 'aqua'
  | 'yellow'
  | 'blue'
  | 'red-outlined'
  | 'pink';

interface Props {
  variant?: ButtonVariant;
  icon?: string;
  type?: 'button' | 'submit' | 'reset';
  to?: string | null;
  block?: boolean;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiButton',
  props: {
    variant: { default: 'red' },
    icon: { default: undefined },
    type: { default: 'button' },
    to: { default: null },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: ButtonVariant, icon: string, type: 'button' | 'submit' | 'reset', to: string | null, block: boolean, disabled: boolean };




const clickEvent = () => {
  emit('click');
};

const classes = computed(() => [
  props.block && 'cn-button--block',
  props.disabled && 'cn-button--disabled',
]);

return { __sfc: true,props, emit, clickEvent, classes, UiButtonInner }
}

})